import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { isNil } from 'src/app/angular-wallet-base/ts-util';

@Component({
  selector: 'app-expiry-custom',
  templateUrl: './expiry-custom.component.html',
  styleUrls: ['./expiry-custom.component.scss']
})
export class ExpiryCustomComponent implements OnInit {

  public isDesktopMode: boolean;
  public hour: number = 0;
  public minutes: number = 0;
  public customExpiry: any;
  public showError = false;

  constructor(
    public appMode: AppModeService,
    private modalCtrl: ModalController
  ) {
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  ngOnInit() { }

  async setCustomExpiry() {
    this.showError = false;

    if ((isNil(this.hour) || this.hour === 0) && (isNil(this.minutes) || this.minutes === 0)) {
      await this.goBack();
    }

    if (isNaN(this.hour) || isNaN(this.minutes) || this.hour < 0 || this.minutes < 0) {
      this.showError = true;
      return;
    }

    if (this.hour) {
      this.hour += this.minutes ? parseFloat((this.minutes / 60).toFixed(2)) : 0;
      await this.modalCtrl.dismiss(
        {
          name: this.hour <= 1 ? 'hour' : 'hours',
          type: 'hour',
          value: this.hour
        }
      );
    } else {
      await this.modalCtrl.dismiss(
        {
          name: this.minutes <= 1 ? 'min' : 'mins',
          type: 'minutes',
          value: this.minutes
        }
      );
    }
  }

  async goBack() {
    await this.modalCtrl.dismiss();
  }

}
